import React from "react";
import { RxCross1 } from "react-icons/rx";
import Excel from "../../../assets/img/excel.png";
import Word from "../../../assets/img/word.png";
import Pdf from "../../../assets/img/pdf.png";

const SopsFilePreview = ({
  files = [],
  handleDelete,
  setDeleteImg,
  Tag = "a",
  cancel = true,
}) => {
  if (!files || files.length === 0) {
    return <div>--</div>;
  }

  const renderFileCard = (fileObj, index) => {
    const fileUrl = fileObj.file;
    const fileName = fileObj.filename || "Unnamed File";
    const extension = fileUrl?.split(".").pop()?.toLowerCase();

    let iconSrc = null;
    if (["pdf"].includes(extension)) iconSrc = Pdf;
    if (["doc", "docx"].includes(extension)) iconSrc = Word;
    if (["xls", "xlsx", "csv"].includes(extension)) iconSrc = Excel;

    const isVideo = ["mp4", "webm", "mov"].includes(extension);
    const isImage = ["jpg", "jpeg", "png", "gif", "webp"].includes(extension);

    return (
      <div
        key={index}
        className={
          handleDelete && setDeleteImg
            ? "col-sm-4 col-md-3 col-lg-2"
            : "col-6 col-sm-4 col-md-4 col-lg-4"
        }
      >
        <div className="img-file-wrap">
          <div className="card img-fluid">
            {isVideo ? (
              <video controls style={{ width: "100%", height: "150px" }}>
                <source src={fileUrl} type={`video/${extension}`} />
              </video>
            ) : (
              <Tag href={fileUrl} target="_blank" rel="noopener noreferrer">
                {isImage ? (
                  <img
                    style={{ height: "150px" }}
                    className="card-img-top"
                    src={fileUrl}
                    alt={fileName}
                  />
                ) : (
                  <img src={iconSrc} alt="file-icon" />
                )}
                <span className="imge-name-over">{fileName}</span>
              </Tag>
            )}

            <div className="card-img-overlay">
              <div className="overlay-text-wrap">
                <p className="card-title">
                  {handleDelete && setDeleteImg && cancel && (
                    <RxCross1
                      onClick={() => {
                        handleDelete();
                        setDeleteImg(index);
                      }}
                      style={{
                        color: "red",
                        cursor: "pointer",
                        fontSize: "18px",
                      }}
                    />
                  )}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  return (
    <div className="col-md-10 images-before-name">
      <div className="row">
        {files.map((fileObj, index) => renderFileCard(fileObj, index))}
      </div>
    </div>
  );
};

export default SopsFilePreview;
